import * as React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material/styles';

export default function BackdropComponent() {
    const theme = useTheme();
    const backdropStyle = {
        position: 'absolute',
        zIndex: theme.zIndex.drawer + 1,
        color: 'white',
        top: '50%',
        left: '50%'
    };

    return (
        <Box sx={backdropStyle}>
            <CircularProgress color="inherit" />
        </Box>
    );
}